import React from "../_snowpack/pkg/react.js";
import styled from "../_snowpack/pkg/@emotion/styled.js";
import {t} from "../common/i18n.js";
import {Title} from "./typo.js";
import Stack from "./stack.js";
import {withAttrs} from "../common/utils.js";
import CartItem from "./cart-item.js";
import {useCartStore} from "../stores/cart.js";
export default function Cart(props) {
  const {cart, removeItem} = useCartStore();
  const {items} = cart;
  return /* @__PURE__ */ React.createElement(Container, null, /* @__PURE__ */ React.createElement(Headline, {
    level: 2
  }, t("Dein Warenkorb")), items.map((i) => /* @__PURE__ */ React.createElement(CartItem, {
    key: i.id,
    onDeleteClick: removeItem,
    ...i,
    widthButtons: true,
    withOptions: true,
    withVariants: true
  })));
}
const Container = styled(withAttrs(Stack, {spacing: "l"}))``;
const Headline = styled(Title)`
  font-size: 24px;
`;
